export default __webpack_public_path__ + "static/media/Badge.ccc7cc1e.svg";